import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { handleResponseCode } from "../../../../app/utilities/helpers";
import GetProxy from "../../../../app/GetProxy";

const cookies = new Cookies();
const proxy = GetProxy();

export const getRoleMappingList = createAsyncThunk(
  "post/getRoleMappingList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/roleMapping/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const testConnectionForGroups = createAsyncThunk(
  "post/testConnectionForGroups",
  async (payload) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/roleMapping/testConnectionForGroups`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const saveOrUpdateRoleMapping = createAsyncThunk(
  "post/saveOrUpdateRoleMapping",
  async (payload) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/roleMapping/saveOrUpdate`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const UserRoleMapSlice = createSlice({
  name: "UserRoleMapSlice",
  initialState: {
    roleMappingListData: [],
    roleMappingTotalCount: 0,
    roleMappingLoading: false,
    roleMappingActionLoading: false,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRoleMappingList.pending, (state) => {
        state.roleMappingLoading = true;
      })
      .addCase(getRoleMappingList.fulfilled, (state, action) => {
        state.roleMappingListData = action.payload.data;
        state.roleMappingTotalCount = action.payload.totalCount;
        state.roleMappingLoading = false;
      })
      .addCase(getRoleMappingList.rejected, (state) => {
        state.roleMappingLoading = false;
        state.roleMappingListData = [];
        state.roleMappingTotalCount = 0;
        state.error = "Something went wrong";
      })
      .addCase(testConnectionForGroups.pending, (state) => {
        state.roleMappingActionLoading = true;
      })
      .addCase(testConnectionForGroups.fulfilled, (state) => {
        state.roleMappingActionLoading = false;
      })
      .addCase(testConnectionForGroups.rejected, (state) => {
        state.roleMappingActionLoading = false;
      })
      .addCase(saveOrUpdateRoleMapping.pending, (state) => {
        state.roleMappingActionLoading = true;
      })
      .addCase(saveOrUpdateRoleMapping.fulfilled, (state) => {
        state.roleMappingActionLoading = false;
      })
      .addCase(saveOrUpdateRoleMapping.rejected, (state) => {
        state.roleMappingActionLoading = false;
      });
  },
});

export default UserRoleMapSlice.reducer;
